import { useCallback } from "react";
import { useErrorMessageTranslationsT } from "src/translation-hooks/error-message-translations";
import { LoginException } from "./error-types";
import { ErrorCodes } from "src/backend/openapi/v1";

export const useLoginErrorTranslation = () => {
  const errorMessageTranslationsT = useErrorMessageTranslationsT();

  const getLoginErrorTranslation = useCallback(
    (exception: LoginException) => {
      switch (exception.error_code) {
        case ErrorCodes.PublicLoginFailedLoginDisabled:
          return errorMessageTranslationsT.publicLoginFailedLoginDisabled;
        case ErrorCodes.PublicLoginInvalidPassword:
          return errorMessageTranslationsT.publicLoginInvalidPassword;
        case ErrorCodes.PublicLoginFailedUnknownIdentity:
          return errorMessageTranslationsT.publicLoginFailedUnknownIdentity;
        default:
          return exception.error_description;
      }
    },
    [errorMessageTranslationsT]
  );

  return { getLoginErrorTranslation };
};
